import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { DeleteOutline as DeleteIcon, Undo as UndoIcon } from '@mui/icons-material';

export interface FlatTreeProperty { normalized_address: string; flats: string[] }

export const unitKey = (address: string, flat: string) => `${address}||${flat}`;

// Buildings with their flats underneath; the delete button on a flat marks it for removal (at most `mustRemove`).
const FlatRemovalTree: React.FC<{
  properties: FlatTreeProperty[];
  removed: Set<string>;
  mustRemove: number;
  onToggle: (key: string) => void;
}> = ({ properties, removed, mustRemove, onToggle }) => (
  <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1, maxHeight: 260, overflowY: 'auto' }}>
    {properties.map(p => (
      <Box key={p.normalized_address}>
        <Typography sx={{ px: 2, py: 1, fontWeight: 700, fontSize: '0.9rem', bgcolor: 'action.hover' }}>
          {p.normalized_address}
        </Typography>
        {p.flats.map(flat => {
          const key = unitKey(p.normalized_address, flat);
          const isRemoved = removed.has(key);
          return (
            <Box key={key} sx={{ display: 'flex', alignItems: 'center', pl: 4, pr: 1, py: 0.25 }}>
              <Typography sx={{ flex: 1, textDecoration: isRemoved ? 'line-through' : 'none', color: isRemoved ? 'text.disabled' : 'text.primary' }}>
                {flat}
              </Typography>
              <IconButton
                size="small"
                aria-label={isRemoved ? `Keep ${flat}` : `Delete ${flat}`}
                onClick={() => onToggle(key)}
                disabled={!isRemoved && removed.size >= mustRemove}
              >
                {isRemoved ? <UndoIcon fontSize="small" /> : <DeleteIcon fontSize="small" />}
              </IconButton>
            </Box>
          );
        })}
      </Box>
    ))}
  </Box>
);

export default FlatRemovalTree;
